import {
  ChevronDown,
  KeyRound,
  LogOut,
  Pencil,
  Trash2,
  UserCheck,
  UserCog,
  UserX,
} from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function UsersTableActionButtons({
  selectedIds = [],
  selectedData = [],
  canEditUser,
  canDeleteUser,
  canResetPassword,
  userIsAdmin,
  onEditUser,
  onEditRoles,
  onResetPassword,
  onDeleteUser,
  onDeactivateUsers,
  onReactivateUsers,
  onForceLogoutUsers,
}) {
  const selectedUsers = selectedData.filter(u => selectedIds.includes(u.id));
  const checkedContainsAdmin = selectedUsers.some(
    u => u.role?.id === -1 // SYSTEM_ROLES.ADMIN
  );
  const allSelectedAreActive = selectedUsers.every(
    u => u.status === "active" || !u.status
  );
  const allSelectedAreDeactivated = selectedUsers.every(
    u => u.status === "deactivated"
  );

  // Only an admin may act on a selection that includes an admin.
  if (
    (!canEditUser && !canDeleteUser && !canResetPassword) ||
    (checkedContainsAdmin && !userIsAdmin)
  ) {
    return null;
  }

  const hasMultipleSelected = selectedIds.length > 1;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        disabled={selectedIds.length === 0}
        className={buttonVariants({ variant: "outline" })}
      >
        Actions
        <ChevronDown />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw:w-auto">
        <DropdownMenuGroup>
          {!hasMultipleSelected && canEditUser && (
            <DropdownMenuItem
              onClick={() =>
                onEditUser(selectedData.find(({ id }) => id === selectedIds[0]))
              }
            >
              <Pencil />
              Edit User
            </DropdownMenuItem>
          )}
          {hasMultipleSelected && canEditUser && (
            <DropdownMenuItem onClick={() => onEditRoles(selectedIds)}>
              <UserCog />
              Edit User Roles
            </DropdownMenuItem>
          )}
          {canResetPassword && (
            <DropdownMenuItem
              onClick={() => onResetPassword(selectedIds, selectedData)}
            >
              <KeyRound />
              {hasMultipleSelected ? "Reset Passwords" : "Reset Password"}
            </DropdownMenuItem>
          )}
          {canEditUser && allSelectedAreActive && (
            <DropdownMenuItem
              onClick={() => onDeactivateUsers(selectedIds, selectedData)}
            >
              <UserX />
              {hasMultipleSelected ? "Deactivate Users" : "Deactivate User"}
            </DropdownMenuItem>
          )}
          {canEditUser && allSelectedAreDeactivated && (
            <DropdownMenuItem
              onClick={() => onReactivateUsers(selectedIds, selectedData)}
            >
              <UserCheck />
              {hasMultipleSelected ? "Reactivate Users" : "Reactivate User"}
            </DropdownMenuItem>
          )}
          {canEditUser && (
            <DropdownMenuItem
              onClick={() => onForceLogoutUsers(selectedIds, selectedData)}
            >
              <LogOut />
              {hasMultipleSelected ? "Force Logout Users" : "Force Logout"}
            </DropdownMenuItem>
          )}
          {canDeleteUser && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => onDeleteUser(selectedIds, selectedData)}
            >
              <Trash2 />
              {hasMultipleSelected ? "Delete Users" : "Delete User"}
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
